export enum EntityViewDisplay {
    Card = 'Card',
    Kanban = 'Kanban',
    List = 'List',
    TreeList = 'TreeList',
}

export enum EntityViewVisibility {
    Private = 'Private',
    Public = 'Public',
    Shared = 'Shared'
}

export enum EntityViewSortDirection {
    Asc = 'Asc',
    Desc = 'Desc'
}

export enum EntityViewType {
    System = 'System',
    Embedded = 'Embedded',
    User = 'User'
}